export default __webpack_public_path__ + "static/media/shop2.4f3e903d.svg";